"use client";
import { useState as l, useEffect as i } from "react";
import { registerStoryblokBridge as u } from "@storyblok/js";
const g = (t = null, n = {}) => {
  const [r, o] = l(null), e = (t == null ? void 0 : t.id) ?? null;
  return i(() => {
    o(null);
  }, [e]), i(() => {
    !(typeof window < "u" && typeof window.storyblokRegisterEvent < "u") || !e || u(
      e,
      (d) => o(d),
      n
    );
  }, [e, n]), r && r.id === e ? r : t;
};
export {
  g as useStoryblokState
};
